import { Controller } from "@hotwired/stimulus";

export class TrackFilterToggleController extends Controller {
  static targets = ["trackFilterTypeSelect", "track", "ticketTypes", "report"];

  connect() {
    this.setVisibility();
  }

  setVisibility() {
    switch (this.trackFilterTypeSelectTarget.value) {
    case "matches_track":
      this.setTrackVisibility(true);
      this.setTicketTypeVisibility(false);
      this.setReportVisibility(false);
      break;
    case "matches_ticket_type":
      this.setTrackVisibility(false);
      this.setTicketTypeVisibility(true);
      this.setReportVisibility(false);
      break;
    case "report":
      this.setTrackVisibility(false);
      this.setTicketTypeVisibility(false);
      this.setReportVisibility(true);
      break;
    default:
      this.setTrackVisibility(false);
      this.setTicketTypeVisibility(false);
      this.setReportVisibility(false);
    }
  }

  setTrackVisibility(visible) {
    this.toggleAll(this.trackTargets, visible);
  }

  setTicketTypeVisibility(visible) {
    this.toggleAll(this.ticketTypesTargets, visible);
  }

  setReportVisibility(visible) {
    this.toggleAll(this.reportTargets, visible);
  }

  toggleAll(elements, visible) {
    elements.forEach((el) => {
      const wrapper = el.closest(".FormControl") || el.closest(".FormControl-check-group-wrap") || el.parentElement;

      // GR-1779: setting el.hidden already reflects to the `hidden`
      // attribute (and vice versa) — the duplicate setAttribute /
      // removeAttribute were no-ops with the same effect.
      el.hidden = !visible;
      if (wrapper) {
        wrapper.classList.toggle("FormControl-check-group-wrap--hidden", !visible);
        if (visible) {
          wrapper.style.removeProperty("display");
        } else {
          wrapper.style.display = "none";
        }
      }
    });
  }
}
